import { modalReducer } from '@xcritical/modal';
import { reducer as formReducer } from '@xcritical/forms';

import { gridReducer } from '@crm-framework/grid';
import { signalRReducer } from '@crm-framework/signalr';
import { registryReducer } from '@crm-framework/registry';
import { authReducer } from '@crm-framework/auth';

import { dictionariesReducer } from '@crm-package/dictionaries';
import { layoutsReducer } from '@crm-package/layouts/store';
import { appReducer } from '@crm-package/app';
import { notificationsReducer } from '@crm-package/notifications';
import { importsReducer } from '@crm-package/imports';

export const coreReducers = {
  app: appReducer,
  dictionaries: dictionariesReducer,
  registry: registryReducer,
  auth: authReducer,
  grid: gridReducer,
  form: formReducer,
  notifications: notificationsReducer,
  signalR: signalRReducer,
  layouts: layoutsReducer,
  modal: modalReducer,
  imports: importsReducer,
};
